import {
    Card,
    CardHeader,
    CardContent,
    Stack,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import StatBar from 'components/StatBar';


const TopCrewsCard = ({ data = [], onCrewClick }) => {
  if (!data.length) return null;

  return (
    <Card 
      sx={{ 
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 1, 
        border: `1px solid`,
        borderColor: "neutral.deep",
      }}
    >
      <CardHeader
        title="Top Crews by Logs"
        subheader=""
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 2,
          backgroundColor: "background.paper",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      />
      <CardContent
        sx={{
          overflowY: "auto",
          flex: 1,
        }}
      >
        <Stack spacing={1}>
          {data?.map((c) => (
            <StatBar
              key={c.label}
              icon={<GroupIcon fontSize="small" color="secondary" />}
              label={c.label}
              count={c.count}
              percent={c.percent}
              color="secondary.main"
              onClick={() => onCrewClick(c)}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default TopCrewsCard;
